import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableScrollFn = /* @__PURE__ */ createRecipe('table-scroll', {}, [])

const tableScrollVariantMap = {}

const tableScrollVariantKeys = Object.keys(tableScrollVariantMap)

export const tableScroll = /* @__PURE__ */ Object.assign(memo(tableScrollFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableScroll',
  __getCompoundVariantCss__: tableScrollFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableScrollVariantKeys,
  variantMap: tableScrollVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableScrollVariantKeys)
  },
  getVariantProps: tableScrollFn.getVariantProps,
})